module.exports = __webpack_public_path__ + "img/Trophy Cup Table43.2482a82f.jpg";